export default function HoleEffect({
  children,
  imgSrc,
}: {
  children: React.ReactNode;
  imgSrc?: string;
}) {
  const bgImage = imgSrc
    ? `url('${imgSrc}')`
    : `url('/images/art-coaching-bg.webp')`;
  console.log(bgImage);
  return (
    <div className="">
      <div
        className="bg-cente hidden h-auto w-full overflow-y-scroll bg-fixed md:block"
        style={{
          backgroundImage: `${bgImage}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        {children}
      </div>
      <div
        className="block md:hidden"
        style={{
          backgroundImage: `${bgImage}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        {children}
      </div>
    </div>
  );
}
